import React from 'react';
import DriversTable from './DriversTable';

export default function ClutchDrivers() {
  return <DriversTable title="Clutch rate" orderByChild="payoutFormulaId" equalTo="v6ywzFmFOsei3H0xMyWX" />;
}
